import React, { useState } from "react";
import { Container, Box, Typography } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { LoadingButton } from "@mui/lab";
import ApiService from "../../apis/ApiService";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { toast } from "react-toastify";

export default function ReporteEncuestas(props) {
  const [fechaDesde, setFechaDesde] = useState(null);
  const [fechaHasta, setFechaHasta] = useState(null);
  const [exportando, setExportando] = useState(false);

  async function handleExportar() {
    if (!fechaDesde || !fechaHasta) return;
    setExportando(true);
    try {
      await ApiService.GetEncuestasExcel(
        fechaDesde.format("YYYY-MM-DD"),
        fechaHasta.format("YYYY-MM-DD"),
      );
      toast.success("Excel generado — revisá tu carpeta de descargas");
    } catch (e) {
      console.error("Error al exportar encuestas:", e);
      toast.error("Error al generar el Excel");
    } finally {
      setExportando(false);
    }
  }

  const puedeExportar =
    fechaDesde && fechaHasta && !fechaHasta.isBefore(fechaDesde);

  return (
    <Container maxWidth="xl">
      <Box sx={{ marginBottom: 3 }}>
        <Typography variant="h6">Encuestas Automáticas</Typography>
      </Box>

      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            flexWrap: "wrap",
          }}
        >
          <DatePicker
            label="Fecha desde"
            value={fechaDesde}
            onChange={(val) => setFechaDesde(val)}
            format="DD/MM/YYYY"
            slotProps={{
              textField: { size: "small", sx: { width: 180 } },
            }}
          />

          <DatePicker
            label="Fecha hasta"
            value={fechaHasta}
            onChange={(val) => setFechaHasta(val)}
            format="DD/MM/YYYY"
            minDate={fechaDesde ?? undefined}
            slotProps={{
              textField: { size: "small", sx: { width: 180 } },
            }}
          />

          <LoadingButton
            variant="contained"
            startIcon={<DownloadIcon />}
            loading={exportando}
            loadingPosition="start"
            disabled={!puedeExportar}
            onClick={handleExportar}
            sx={{
              backgroundColor: "#1D6F42",
              ":hover": { bgcolor: "#155534" },
              textTransform: "none",
            }}
          >
            Exportar Excel
          </LoadingButton>
        </Box>
      </LocalizationProvider>
    </Container>
  );
}
